
export enum CategoryEnum{
  Graphics3D ="3D Graphics",
  Animations="Lottie Animations",
  Illustrations="Illustrations",
  Stickers="Stickers",
  Icons="Icons",
}
